var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.visible, title: _vm.$t("Batch_Access") },
      on: { close: _vm.close },
    },
    [
      _c("p", { staticClass: "label" }, [
        _vm._v(_vm._s(_vm.$t("TABLE_HEADER_Access_Level"))),
      ]),
      _c("MemberAccessLevelSelect", {
        staticClass: "mb_20",
        attrs: { initData: _vm.accessType },
        on: { change: _vm.getAccessTypeValue },
      }),
      _c("p", { staticClass: "label" }, [
        _vm._v(_vm._s(_vm.$t("MEMBER_TABLE_HEADER_CLIENT_ENTITIES"))),
      ]),
      !_vm.accessType
        ? _c("el-select", {
            staticStyle: { width: "100%" },
            attrs: { value: "" },
          })
        : _vm.accessType === "ALL"
        ? _c("el-select", {
            staticClass: "mb_20",
            staticStyle: { width: "100%" },
            attrs: { disabled: "", value: _vm.$t("All_ENTITIES") },
          })
        : _c("select-tree", {
            staticClass: "mb_20",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.data,
              filterable: true,
              "check-strictly": true,
              defaultCheckedKeys: _vm.defaultCheckedKeys,
              defaultExpandAll: true,
              defaultProps: _vm.defaultProps,
            },
            on: { "visible-change": _vm.handleVisibleChange },
          }),
      _c(
        "footer",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { staticClass: "btn-cancel", on: { click: _vm.close } },
            [_vm._v("\n      " + _vm._s(_vm.$t("btn_cancel")) + "\n    ")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("\n      " + _vm._s(_vm.$t("btn_confirm")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }